import { omit } from 'lodash'
import type { Schema } from '@wix/wix-data-schema-types'
import {
  PUBLISHING_PLUGIN_ID,
  PUBLISH_STATUS_FIELD_KEY,
  PUBLISH_DATE_FIELD_KEY,
  DRAFT_DATE_FIELD_KEY,
} from '@wix/wix-data-schema-types'

import type { ImplicitPluginFixes } from '../types'

const publishingPluginDisabled = (schema: Schema): boolean =>
  !schema.plugins?.[PUBLISHING_PLUGIN_ID]

const removePublishingFields = (schema: Schema): Schema => ({
  ...schema,
  fields: omit(schema.fields, [
    PUBLISH_STATUS_FIELD_KEY,
    PUBLISH_DATE_FIELD_KEY,
    DRAFT_DATE_FIELD_KEY,
  ]),
})

export const applyImplicitPublishingPluginFixes = ({
  schema,
}: ImplicitPluginFixes): ImplicitPluginFixes => ({
  schema: publishingPluginDisabled(schema)
    ? removePublishingFields(schema)
    : schema,
})
